import { ElementSource } from "chq";
import secondsToTimeString from "./secondsToTimeString";

type Subtitle = {
  language: string;
  default: boolean;
  text: string;
};

const updateSubtitlesText = (
  subtitleElements: ElementSource[]
): Subtitle[] => {
  // Pre-sort all elements once
  const sortedElements = [...subtitleElements].sort((a, b) => a.time - b.time);

  const subtitlesPerLanguage: Record<string, ElementSource[]> = {};

  // Group pre-sorted elements (they'll maintain their sort order)
  sortedElements.forEach(element => {
    const [_prefix, _index, language] = element.name.split("-", 3);
    if (!subtitlesPerLanguage[language]) {
      subtitlesPerLanguage[language] = [];
    }
    subtitlesPerLanguage[language].push(element);
  });

  return Object.entries(subtitlesPerLanguage)
    .map(([language, elements]) => {
      let isDefaultLanguage = true;

      const newText = elements.map((element, index) => {
        if (element.visible === false) isDefaultLanguage = false;
        const endTime = element.time + element.duration;
        return [
          index,
          `${secondsToTimeString(element.time)} --> ${secondsToTimeString(endTime)}`,
          element.text
        ].join("\n");
      }).join("\n\n");

      return {
        language,
        default: isDefaultLanguage,
        text: `WEBVTT\n\n${newText}`
      };
    });
};

export default updateSubtitlesText;
